import { useEventListener } from '@vueuse/core'
import { computed, onMounted, ref } from 'vue'

import { useBrowserResize } from './useBrowserResize'


export function useScroll(config?: {
  scrollDownEvent?: (position: number) => void,
  scrollUpEvent?: (position: number) => void,
  targetElement?: HTMLElement | null,
}) {
  const { innerHeight, isMobile } = useBrowserResize()
  const target = config?.targetElement || window
  const pageHeight = ref(0)
  const scrollDirection = ref('')
  const lastScroll = ref(0)
  const scrollTop = ref(0)
  const scrollHeight = ref(0)
  const isScrollTop = computed(() => lastScroll.value === 0)
  const isScrollInsightHeader = computed(() => lastScroll.value > 120)
  const isScrollAnalyticsHeader = computed(() => lastScroll.value > 30)
  const footerTop = computed(() => (isMobile ? 1005 : 327))

  const handlerList = ref<(() => void)[]>([])
  const setScrollHandler = (handler: () => void) => {
    handlerList.value.push(handler)
  }

  const isScrollFooterTop = computed(() => {
    if (pageHeight.value <= 0) return true
    return lastScroll.value >= pageHeight.value - footerTop.value
  })
  const isScrollBottom = computed(() => {
    if (pageHeight.value <= 0) return true
    return lastScroll.value >= pageHeight.value
  })
  const scrollPercentage = ref(0)
  const researchScrollPercentage = ref(0)
  const vw = computed(() =>
    Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
  )
  const vh = computed(() =>
    Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0,
    ),
  )

  function scrollHandler() {
    const scrollY = window.scrollY
    scrollDirection.value = scrollY - lastScroll.value > 0 ? 'down' : 'up'
    scrollTop.value = document.body.scrollTop
    scrollHeight.value = document.documentElement.scrollHeight
    lastScroll.value = scrollY
    scrollPercentage.value = getScrollPercent()
    researchScrollPercentage.value = getStartingPointScrollPercent(125)

    pageHeight.value =
      document.documentElement.offsetHeight - window.innerHeight

    if (scrollDirection.value === 'down') {
      config?.scrollDownEvent && config?.scrollDownEvent(lastScroll.value)
    } else {
      config?.scrollUpEvent && config?.scrollUpEvent(lastScroll.value)
    }

    handlerList.value.map(handler => {
      handler()
    })
  }

  function getScrollPercent() {
    return Number(
      (
        ((lastScroll.value + innerHeight.value) / document.body.clientHeight) *
        100
      ).toFixed(2),
    )
  }

  function getStartingPointScrollPercent(startingPoint = 0) {
    return Number(
      Math.min(
        100,
        ((lastScroll.value - startingPoint) /
          (document.body.offsetHeight - window.innerHeight - startingPoint)) *
          100,
      ).toFixed(2),
    )
  }
  onMounted(() => {
    useEventListener(target, 'scroll', scrollHandler)
  })

  return {
    vh,
    vw,
    scrollDirection,
    scrollTop,
    lastScroll,
    isScrollTop,
    isScrollInsightHeader,
    isScrollAnalyticsHeader,
    scrollPercentage,
    researchScrollPercentage,
    isScrollFooterTop,
    isScrollBottom,
    setScrollHandler,
  }
}
